import {
  Component,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  HostListener,
  ChangeDetectorRef,
  AfterViewChecked,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Title } from "@angular/platform-browser";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { cloneDeep } from "lodash";

import { Color } from "@angular-material-components/color-picker";
import { MatSelectionListChange } from "@angular/material/list";
import { MatDialog } from "@angular/material/dialog";

import { BehaviorSubject, EMPTY, Observable, Subscription, zip } from "rxjs";
import { catchError, finalize, skip, take, tap } from "rxjs/operators";
import { select, Store } from "@ngrx/store";
import {
  createProduct,
  getBarcodeTypes,
  getCategoriesByUsage,
  getFamilyProductsList,
  getGroupProductsList,
  getProduct,
  getProductSiteList,
  getProductTypesList,
  getPropertiesByUsage,
  getUnitProductsList,
  resetProduct,
  updateProduct,
} from "src/app/store/actions/products/product.actions";
import { getProductGroupList } from "src/app/store/actions/productGroups/productGroup.actions";
import { getProductFamiliesList } from "src/app/store/actions/productFamilies/productFamilies.actions";
import {
  AppState,
  createdProductState,
  loadedBarcodeTypesListState,
  loadedFamilyListState,
  loadedProductGroupsListState,
  loadedProductIsLoadingState,
  loadedProductsCategoriesState,
  loadedProductsPropertiesState,
  loadedProductState,
  loadedProductTypesListState,
  loadedProductUnitListState,
  loadedTenantState,
  messagesStateGetMessage,
} from "src/app/store/reducers";
import { setSnackbar } from "src/app/store/actions/messages/message.actions";
import { getSitesList } from "src/app/store/actions/sites/sites.actions";

import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "src/app/shared/services/snackbar/snackbar.service";
import { TaxesService } from "src/app/shared/services/taxes/taxes.service";

import { AppMessage } from "src/app/models/common/appMessage";
import { FormatPipe } from "src/app/shared/pipes/formatPipe";
import { FormUtils } from "src/app/shared/utils/formUtils";
import { SnackbarType } from "src/app/models/snackbar/snackbar.model";
import {
  BarcodeTypeDTO,
  PackDTO,
  PackExtendedDTO,
  ProductDTO,
  ProductFamilyDTO,
  ProductGroupDTO,
  ProductTypeDTO,
  ProductUnitDTO,
} from "src/app/models/Products/productDTO";
import { TopCard } from "src/app/models/top-card/top-card.model";
import { CategoryDTO } from "src/app/models/Categories/categoryDTO";
import { PropertyDTO } from "src/app/models/Properties/propertyDTO";
import { CategoriesAndPropsUtils } from "src/app/shared/utils/categoriesAndPropsUtils";
import { CanComponentDeactivate } from "src/app/shared";
import {
  Dialog,
  GuardConfirmationDialogData,
} from "src/app/models/dialog/dialog.model";
import { AutocompleteSelectItem } from "src/app/models/selection-list/autocomplete-select-item.model";
import { TaxDTO } from "src/app/models/taxes/tax.model";
import { isAuthenticated } from "src/app/shared/utils/authenticationUtils";
import { getColorByBgColor } from "src/app/shared/utils/colorUtils";
import { SnackBarUtils } from "src/app/shared/utils/snackbarUtils";

import { ConfirmationDialogComponent } from "src/app/shared/modules/dialogs/confirmation-dialog/confirmation-dialog.component";

const USAGE_CODE = "PRODUCT";

export const FORM_PARAMS = {
  enabled: "enabled",
  isFuel: "isFuel",
  promptQuantity: "promptQuantity",
  customPrice: "customPrice",
  promptPrice: "promptPrice",
  priceByWeight: "priceByWeight",
  fiscalInfoRequired: "fiscalInfoRequired",
  refundable: "refundable",
  canSellBelowBuyPrice: "canSellBelowBuyPrice",
  description: "description",
  productUnitCode: "productUnitCode",
  productTypeCode: "productTypeCode",
  productFamily: "productFamily",
  productGroup: "productGroup",
  tax: "tax",
  referenceUnitPrice: "referenceUnitPrice",
  defaultQuantity: "defaultQuantity",
  refundMaxPeriod: "refundMaxPeriod",
  productColor: "productColor",
  imageUrl: "imageUrl",
  shortDescription: "shortDescription",
  lastSaleDate: "lastSaleDate",
  lastBuyDate: "lastBuyDate",
  lastSalePrice: "lastSalePrice",
  lastBuyPrice: "lastBuyPrice",
  maxSellDiscount: "maxSellDiscount",
  categories: "categories",
  properties: "properties",
  barcodes: "barcodes",
  pack: "pack",
  productPack: "productPack",
};

@Component({
  selector: "app-product-detail",
  templateUrl: "./product-detail.component.html",
  styleUrls: ["./product-detail.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ProductDetailComponent
  implements OnInit, OnDestroy, AfterViewChecked, CanComponentDeactivate
{
  productInfoTabs = [
    {
      description: "Tabs.BasicData",
      icon: "description",
      selected: true,
    },
    {
      description: "Products.barcodes",
      icon: "qr_code",
      selected: false,
    },
    {
      description: "Products.packs",
      icon: "layers",
      selected: false,
    },
    {
      description: "Tabs.Suppliers",
      icon: "local_shipping",
      selected: false,
    },
  ];

  //Product
  isLoading$: Observable<boolean>;
  loadedProduct$: Observable<ProductDTO>;
  created$: Observable<boolean>;

  //top-card configuration
  card: TopCard;
  icon: any = "add";

  //ProductFamily
  isLoadingProductFamily$: Observable<boolean>;
  productFamiliesList$: Observable<ProductFamilyDTO[]>;
  productFamiliesList: AutocompleteSelectItem[] = [];
  productFamiliesSub: Subscription;

  //ProductGroup
  isLoadingProductGroup$: Observable<boolean>;
  productGroupsList$: Observable<ProductGroupDTO[]>;
  productGroupsList: AutocompleteSelectItem[] = [];
  productGroupsSub: Subscription;

  //Tax
  isLoadingTax$ = new BehaviorSubject<boolean>(false);
  taxesList$: Observable<TaxDTO[]>;
  taxesList: AutocompleteSelectItem[] = [];
  taxesSub: Subscription;

  searchTimer: number;

  //ProductUnit
  productUnit$: Observable<ProductUnitDTO[]>;
  productUnit: ProductUnitDTO[];

  //ProductTypes
  productTypes$: Observable<ProductTypeDTO[]>;
  productTypes: ProductTypeDTO[];

  //Category List
  categoryList$: Observable<CategoryDTO[]>;
  categoryList: CategoryDTO[];

  //Property List
  propertyList$: Observable<PropertyDTO[]>;
  propertyList: PropertyDTO[];

  //Barcode Types
  barcodeTypes$: Observable<BarcodeTypeDTO[]>;

  //Subscriptions
  loadedProductSubs: Subscription;
  createdSub: Subscription;
  multiSubs: Subscription;
  volumeSub: BehaviorSubject<string>;

  //Tenant Data
  tenantDataSub: Subscription;
  tenantData$: Observable<any>;
  fuelUnitPriceDecimalPlaces: number;
  unitPriceDecimalPlaces: number;
  dateTimeFormat: string;

  //Messages
  message$: Observable<AppMessage>;
  messageSubs: Subscription;

  //Navigation
  currCode: string;

  currentProduct: ProductDTO;
  current: any;

  //Actions
  creation: boolean = false;
  duplication: boolean = false;

  //Form
  productDataForm: FormGroup;

  //Language
  langSubscription: Subscription;

  // loaded locale
  public locale: string = localStorage.getItem("locale");

  constructor(
    private translate: TranslateService,
    private fb: FormBuilder,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private store: Store<AppState>,
    private snackbarService: SnackbarService,
    private taxesService: TaxesService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {
    this.titleService.setTitle(this.translate.instant("Products.Details"));
    this.isLoading$ = this.store.pipe(select(loadedProductIsLoadingState));
    this.tenantData$ = this.store.pipe(select(loadedTenantState));
    this.message$ = this.store.pipe(select(messagesStateGetMessage));
    this.loadedProduct$ = this.store.pipe(select(loadedProductState));
    this.created$ = this.store.pipe(select(createdProductState));
    this.productGroupsList$ = this.store.pipe(select(loadedProductGroupsListState));
    this.productFamiliesList$ = this.store.pipe(select(loadedFamilyListState));
    this.productUnit$ = this.store.pipe(select(loadedProductUnitListState));
    this.productTypes$ = this.store.pipe(select(loadedProductTypesListState));
    this.barcodeTypes$ = this.store.pipe(select(loadedBarcodeTypesListState));
    this.categoryList$ = this.store.pipe(select(loadedProductsCategoriesState));
    this.propertyList$ = this.store.pipe(select(loadedProductsPropertiesState));

    this.card = {
      avatarUrl: "",
      content: "",
      imageUrl: "",
      current: "",
      title: "Products.newProduct",
      subtitle: this.duplication ? "Products.duplication" : "Products.creation",
    };
  }

  confirmDialog(dialog: any, refresh = false): Observable<boolean> {
    const dialogData: Dialog = GuardConfirmationDialogData;
    const dialogRef = dialog.open(ConfirmationDialogComponent, dialogData);
    if (!refresh) {
      return dialogRef.afterClosed();
    }
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.reload();
      }
    });
  }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "ignore";

    this.route.params.subscribe((params) => {
      const code = params.id;
      this.creation = false;
      this.duplication = false;
      const duplicateCode = localStorage.getItem("duplicate");

      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      if (code && code.length) {
        this.initialiseState(code, false);
      } else if (duplicateCode !== null) {
        this.duplication = true;
        localStorage.removeItem("duplicate");
        this.initialiseState(duplicateCode, true);
      } else {
        this.creation = true;
        this.initialiseState("", false);
      }
    });

    this.loadTenantData();

    //Initialize FormGroup
    this.createProductForm();
    this.loadProductInfo();
    this.loadLangChanges();
    this.resetCreation();

    //Search subscriptions
    this.setProductFamilySearchSubscription();
    this.setProductGroupSearchSubscription();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  loadTenantData(): void {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.fuelUnitPriceDecimalPlaces = data.fuelUnitPriceDecimalPlaces;
        this.unitPriceDecimalPlaces = data.unitPriceDecimalPlaces;
        this.dateTimeFormat = data.datetimeFormat;
      }
    });
  }

  resetCreation() {
    this.createdSub = this.created$.pipe(skip(1)).subscribe((created) => {
      if (created) {
        this.creation = false;
        this.duplication = false;
      }
    });
  }

  createProductForm() {
    this.productDataForm = this.fb.group({
      [FORM_PARAMS.description]: [
        null,
        [Validators.required, FormUtils.noWhitespaceValidator, Validators.maxLength(100)],
      ],
      [FORM_PARAMS.enabled]: [true],
      [FORM_PARAMS.isFuel]: [null],
      [FORM_PARAMS.promptQuantity]: [null],
      [FORM_PARAMS.customPrice]: [null],
      [FORM_PARAMS.promptPrice]: [null],
      [FORM_PARAMS.priceByWeight]: [null],
      [FORM_PARAMS.fiscalInfoRequired]: [null],
      [FORM_PARAMS.fiscalInfoRequired]: [null],
      [FORM_PARAMS.refundable]: [null],
      [FORM_PARAMS.canSellBelowBuyPrice]: [null],
      [FORM_PARAMS.productFamily]: [
        null,
        [
          FormUtils.noWhitespaceValidator,
          FormUtils.isObjectValidator
        ]
      ],
      [FORM_PARAMS.productGroup]: [
        null, 
        [
          FormUtils.noWhitespaceValidator,
          FormUtils.isObjectValidator
        ]
      ],
      [FORM_PARAMS.tax]: [
        null, 
        [
          Validators.required,
          FormUtils.noWhitespaceValidator,
          FormUtils.isObjectValidator
        ]
      ],
      [FORM_PARAMS.productUnitCode]: [null, Validators.required],
      [FORM_PARAMS.productTypeCode]: [null, Validators.required],
      [FORM_PARAMS.defaultQuantity]: [null],
      [FORM_PARAMS.refundMaxPeriod]: [null],
      [FORM_PARAMS.referenceUnitPrice]: [
        null,
        [
          Validators.required, 
          FormUtils.noWhitespaceValidator, 
          Validators.min(0), 
          Validators.pattern(`^[0-9]+(.[0-9]{0,${this.unitPriceDecimalPlaces}})?$`)
        ],
      ],
      [FORM_PARAMS.productColor]: [null],
      [FORM_PARAMS.imageUrl]: [null, Validators.maxLength(300)],
      [FORM_PARAMS.shortDescription]: [
        null,
        [Validators.required, FormUtils.noWhitespaceValidator, Validators.maxLength(100)],
      ],
      [FORM_PARAMS.lastSaleDate]: [{ value: null, disabled: true }],
      [FORM_PARAMS.lastBuyDate]: [{ value: null, disabled: true }],
      [FORM_PARAMS.lastSalePrice]: [{ value: null, disabled: true }],
      [FORM_PARAMS.lastBuyPrice]: [{ value: null, disabled: true }],
      [FORM_PARAMS.maxSellDiscount]: [
        null,
        [Validators.min(0), Validators.max(999999.999)]
      ],
      [FORM_PARAMS.categories]: this.fb.array([]),
      [FORM_PARAMS.properties]: this.fb.array([]),
      [FORM_PARAMS.barcodes]: this.fb.array([]),
      [FORM_PARAMS.productPack]: this.fb.array([]),
    });
    this.onIsFuelChanges(this.productDataForm);
  }

  onIsFuelChanges(productForm: FormGroup) {
    productForm.get(FORM_PARAMS.isFuel).valueChanges.subscribe((isFuel) => {
      if (isFuel) {
        productForm.get(FORM_PARAMS.referenceUnitPrice).setValidators(
          [
            Validators.required, 
            FormUtils.noWhitespaceValidator, 
            Validators.min(0), 
            Validators.pattern(`^[0-9]+(.[0-9]{0,${this.fuelUnitPriceDecimalPlaces}})?$`)
          ]
        );
        if (this.productDataForm.controls.referenceUnitPrice.value) {
          productForm.get(FORM_PARAMS.referenceUnitPrice).setValue(
            Number(this.productDataForm.controls.referenceUnitPrice.value).toFixed(this.fuelUnitPriceDecimalPlaces)
          );
        }
      } else {
        productForm.get(FORM_PARAMS.referenceUnitPrice).setValidators(
          [
            Validators.required, 
            FormUtils.noWhitespaceValidator, 
            Validators.min(0), 
            Validators.pattern(`^[0-9]+(.[0-9]{0,${this.unitPriceDecimalPlaces}})?$`)
          ]
        );
        if (this.productDataForm.controls.referenceUnitPrice.value) {
          productForm.get(FORM_PARAMS.referenceUnitPrice).setValue(
            Number(this.productDataForm.controls.referenceUnitPrice.value).toFixed(this.unitPriceDecimalPlaces)
          );
        }
      }
      productForm.get(FORM_PARAMS.referenceUnitPrice).updateValueAndValidity();
    });
  }

  loadLangChanges() {
    this.langSubscription = this.translate.onLangChange.subscribe(() => {
      this.titleService.setTitle(this.translate.instant("Products.Details"));
    });
  }

  onSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const {
      value: { description },
    } = option;
    this.productInfoTabs = this.productInfoTabs.reduce((acc, cur) => {
      if (cur.description === description) {
        return [...acc, { ...cur, selected: true }];
      }
      return [...acc, { ...cur, selected: false }];
    }, []);
  }

  setProductFamilySearchSubscription() {
    this.productFamiliesSub = this.productFamiliesList$
      .pipe(skip(1))
      .subscribe((productFamilies) => {
        if (productFamilies) {
          this.productFamiliesList = productFamilies.map((productFamily) => {
            const { code, description } = productFamily;
            return {
              code,
              displayCode: code ?? "",
              description,
            };
          });
        }
      });
  }

  setProductGroupSearchSubscription() {
    this.productGroupsSub = this.productGroupsList$
      .pipe(skip(1))
      .subscribe((productGroups) => {
        if (productGroups) {
          this.productGroupsList = productGroups.map((productGroup) => {
            const { code, description } = productGroup;
            return {
              code,
              displayCode: code ?? "",
              description,
            };
          });
        }
      });
  }

  validateFirstProductFamilySearch(event: KeyboardEvent) {
    if (!this.productFamiliesList.length) {
      this.searchProductFamilies(event, false);
    }
  }

  validateFirstProductGroupSearch(event: KeyboardEvent) {
    if (!this.productGroupsList.length) {
      this.searchProductGroups(event, false);
    }
  }

  validateFirstTaxSearch(event: KeyboardEvent) {
    if (!this.taxesList.length) {
      this.searchTaxes(event, false);
    }
  }

  searchProductFamilies(event: KeyboardEvent, hasTimer = true) {
    const { value: searchTerm } = event.target as HTMLInputElement;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.store.dispatch(
          getProductFamiliesList({
            options: {
              filteringArgs: {
                filterConfig: [{ field: "code" }, { field: "description" }],
                searchTerms: [searchTerm],
              },
            },
          })
        );
      },
      hasTimer ? 500 : 0
    );
  }

  searchProductGroups(event: KeyboardEvent, hasTimer = true) {
    const { value: searchTerm } = event.target as HTMLInputElement;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.store.dispatch(
          getProductGroupList({
            options: {
              filteringArgs: {
                filterConfig: [{ field: "code" }, { field: "description" }],
                searchTerms: [searchTerm],
              },
            },
          })
        );
      },
      hasTimer ? 500 : 0
    );
  }

  searchTaxes(event: KeyboardEvent, hasTimer = true) {
    const { value: searchTerm } = event.target as HTMLInputElement;

    clearTimeout(this.searchTimer);
    this.searchTimer = window.setTimeout(
      () => {
        this.isLoadingTax$.next(true);
        this.taxesService.getTaxList(
          undefined,
          {
            filterConfig: [{ field: "description" }, { field: "receiptDescription" }],
            searchTerms: [searchTerm],
          }
        ).pipe(
          take(1),
          tap((result) => {
            const { items } = result;
            this.taxesList = items.map((tax: TaxDTO) => {
              const { code, description } = tax;
              return {
                code,
                displayCode: code ?? "",
                description,
              };
            });
          }),
          catchError((error) => {
            this.store.dispatch(
              setSnackbar(
                SnackBarUtils.setSnackBar(
                  this.translate.instant("Tax.taxesLoadError"),
                  SnackbarType.ERROR
                )
              )
            );
            return EMPTY;
          }),
          finalize(() => this.isLoadingTax$.next(false))
        ).subscribe();
      },
      hasTimer ? 500 : 0
    );
  }

  displayAutocompleteOption(option: {
    code: string;
    displayCode: string;
    description: string;
  }): string {
    return option?.description ?? "";
  }

  openProductFamily() {
    const productFamilyCode = this.productDataForm.controls[FORM_PARAMS.productFamily]?.value?.code;
    if (productFamilyCode) {
      return ["/families/family", productFamilyCode];
    }
  }

  openProductGroup() {
    const productGroupCode = this.productDataForm.controls[FORM_PARAMS.productGroup]?.value?.code;
    if (productGroupCode) {
      return ["/groups/group", productGroupCode];
    }
  }

  openTax() {
    const taxCode = this.productDataForm.controls[FORM_PARAMS.tax]?.value?.code;
    if (taxCode) {
      return ["/taxes/tax", taxCode];
    }
  }

  loadProductInfo() {
    this.multiSubs = zip(
      this.productUnit$.pipe(skip(1)),
      this.productTypes$.pipe(skip(1)),
      this.categoryList$.pipe(skip(1)),
      this.propertyList$.pipe(skip(1))
    ).subscribe(
      ([productUnit, productTypes, categories, properties]) => {
        if (
          productUnit &&
          productUnit !== null &&
          productUnit !== undefined &&
          productUnit?.length > 0
        ) {
          this.productUnit = productUnit;
          if (this.productUnit?.length > 0) {
            this.productUnit = this.productUnit.map((productUnit) => {
              return {
                code: productUnit?.code,
                description: productUnit?.description,
              };
            });
          }
        }

        if (productTypes && productTypes.length) {
          this.productTypes = productTypes;
        }

        if (categories && categories.length) {
          this.categoryList = categories;
        }

        if (properties && properties.length) {
          this.propertyList = properties;
        }

        this.loadedProductSubs = this.loadedProduct$.subscribe(
          (product: any) => {
            if (product) {
              this.currentProduct = cloneDeep(product);

              if (
                (!this.currCode ||
                  (this.currCode && this.currCode?.length === 0)) &&
                !this.duplication
              ) {
                this.currCode = this.currentProduct.code;
              }

              this.creation = false;
              this.card = {
                avatarUrl: "",
                content: "",
                imageUrl: "",
                current: !this.duplication ? product?.code : "",
                title: !this.duplication
                  ? "[" +
                    product?.code +
                    "] - " +
                    (product?.code?.length > 0 ? product?.description : "")
                  : "Products.newProduct",
                subtitle: !this.duplication
                  ? "Products.product"
                  : "Products.duplication",
              };

              this.setProductForm(product);
            }
            if (product || this.creation || this.duplication) {
              if (categories && categories.length) {
                this.categoryList = categories;
              }
              if (properties && properties.length) {
                this.propertyList = properties;
              }
            }
          }
        );
      }
    );
    
    this.store.dispatch(getFamilyProductsList(null));
    this.store.dispatch(getGroupProductsList(null));
    this.store.dispatch(getUnitProductsList(null));
    this.store.dispatch(getProductTypesList(null));
    this.store.dispatch(getBarcodeTypes(null));
    this.store.dispatch(
      getCategoriesByUsage({
        pageReq: {
          query: "is_enabled==1",
          limit: undefined,
          offset: 0,
          realSize: true,
        },
        usageCode: USAGE_CODE,
      })
    );
    this.store.dispatch(
      getPropertiesByUsage({
        pageReq: {
          query: "is_enabled==1",
          limit: undefined,
          offset: 0,
          realSize: true,
        },
        usageCode: USAGE_CODE,
      })
    );
    this.store.dispatch(
      getSitesList({
        options: {
          paging: {
            skip: 0,
            top: 9999,
          },
        },
      })
    );
    this.store.dispatch(
      getProductSiteList({ code: this.currCode })
    );
  }

  setProductForm(product: any) {
    this.productDataForm.controls.enabled.setValue(
      product && product?.enabled && !this.duplication
        ? product?.enabled
        : false
    );
    this.productDataForm.controls.isFuel.setValue(
      product && product?.isFuel ? product?.isFuel : false
    );
    this.productDataForm.controls.promptQuantity.setValue(
      product && product?.promptQuantity ? product?.promptQuantity : false
    );
    this.productDataForm.controls.customPrice.setValue(
      product && product?.customPrice ? product?.customPrice : false
    );
    this.productDataForm.controls.promptPrice.setValue(
      product && product?.promptPrice ? product?.promptPrice : false
    );
    this.productDataForm.controls.priceByWeight.setValue(
      product && product?.priceByWeight ? product?.priceByWeight : false
    );
    this.productDataForm.controls.fiscalInfoRequired.setValue(
      product && product?.fiscalInfoRequired ? product?.fiscalInfoRequired : false
    );
    this.productDataForm.controls.refundable.setValue(
      product && product?.refundable ? product?.refundable : false
    );
    this.productDataForm.controls.canSellBelowBuyPrice.setValue(
      product && product?.canSellBelowBuyPrice ? product?.canSellBelowBuyPrice : false
    );
    this.productDataForm.controls.description.setValue(
      product && product?.description && !this.duplication
        ? product?.description
        : null
    );
    this.productDataForm.controls.shortDescription.setValue(
      product && product?.shortDescription && !this.duplication
        ? product?.shortDescription
        : null
    );
    this.productDataForm.controls[FORM_PARAMS.referenceUnitPrice].setValue(
      product && product?.referenceUnitPrice && !this.duplication
        ? product?.referenceUnitPrice.toFixed(
            product?.isFuel ? this.fuelUnitPriceDecimalPlaces : this.unitPriceDecimalPlaces
          )
        : 0
    );
    this.productDataForm.controls[FORM_PARAMS.defaultQuantity].setValue(
      product && product?.defaultQuantity && !this.duplication
        ? product?.defaultQuantity
        : null
    );
    this.productDataForm.controls.maxSellDiscount.setValue(
      product && product?.maxSellDiscount && !this.duplication 
        ? product?.maxSellDiscount 
        : null
    );
    this.productDataForm.controls[FORM_PARAMS.refundMaxPeriod].setValue(
      product && (product?.refundMaxPeriod || product?.refundMaxPeriod === 0) && !this.duplication
        ? product?.refundMaxPeriod
        : null
    );
    let color = FormUtils.hexToRgb(product?.color);
    this.productDataForm.controls.productColor.setValue(
      color && product?.color && !this.duplication
        ? new Color(color.r, color.g, color.b)
        : null
    );
    this.productDataForm.controls.imageUrl.setValue(
      product && product?.imageUrl && !this.duplication
        ? product?.imageUrl
        : null
    ); 
    this.productDataForm.controls[FORM_PARAMS.productGroup].setValue(
      !product.productGroup
        ? null
        : {
            code: product.productGroup.code,
            displayCode: product.productGroup.code,
            description: product.productGroup.description,
          }
    );
    this.productDataForm.controls[FORM_PARAMS.productFamily].setValue(
      !product.productFamily
        ? null
        : {
            code: product.productFamily.code,
            displayCode: product.productFamily.code,
            description: product.productFamily.description,
          }
    );
    this.productDataForm.controls[FORM_PARAMS.tax].setValue(
      !product.tax
        ? null
        : {
            code: product.tax.code,
            displayCode: product.tax.code,
            description: product.tax.description,
          }
    );
    this.productDataForm.patchValue(
      {
        productUnitCode: product?.productUnit?.code
          ? product?.productUnit?.code
          : null
      },
      { emitEvent: true, onlySelf: false }
    );
    this.productDataForm.patchValue(
      {
        productTypeCode: product?.productTypeCode
          ? product?.productTypeCode
          : null
      },
      { emitEvent: true, onlySelf: false }
    );
    this.setDateField(this.productDataForm, 'lastSaleDate');
    this.setDateField(this.productDataForm, 'lastBuyDate');
    this.productDataForm.controls[FORM_PARAMS.lastSalePrice].setValue(
      product && product?.lastSalePrice && !this.duplication
        ? product?.lastSalePrice.toFixed(
            product?.isFuel ? this.fuelUnitPriceDecimalPlaces : this.unitPriceDecimalPlaces
          )
        : 0
    );
    this.productDataForm.controls[FORM_PARAMS.lastBuyPrice].setValue(
      product && product?.lastBuyPrice && !this.duplication
        ? product?.lastBuyPrice.toFixed(
            product?.isFuel ? this.fuelUnitPriceDecimalPlaces : this.unitPriceDecimalPlaces
          )
        : 0
    );
  }

  setDateField(productForm: FormGroup, fieldParam: string) {
    productForm.controls[FORM_PARAMS[fieldParam]].setValue(
      this.duplication
        ? null
        : FormUtils.setGivenDateTimePickerFormat(
            this.currentProduct[fieldParam],
            this.dateTimeFormat ?? "DD/MM/YYYY HH:mm:ss"
          ) ?? null
    );
  }

  initialiseState(code: string, duplicate?: boolean) {
    if (code) {
      this.loadProduct(code);
      if (duplicate) {
        this.currCode = "";
      } else {
        this.currCode = code;
      }
    } else {
      this.reset();
      this.currCode = "";
      this.card = {
        avatarUrl: "",
        content: "",
        imageUrl: "",
        current: "",
        title: "Products.newProduct",
        subtitle: this.duplication
          ? "Products.duplication"
          : "Products.creation",
      };
    }
  }

  clearFormControl(form: FormGroup, productControl: string): void {
    form.controls[productControl].setValue(null);
    form.markAsDirty();
  }

  getColorPickerBgColor(color: Color): string {
    if (color) {
      return getColorByBgColor(color.hex);
    }
  }

  loadProduct(code: string) {
    if (code && code?.length > 0) {
      this.store.dispatch(getProduct({ code: code }));
    }
  }

  reset() {
    this.store.dispatch(resetProduct());
  }

  back() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.location.back();
  }

  onSubmit() {
    if (!this.productDataForm.valid) {
      this.productDataForm.markAllAsTouched();
      this.snackbarService.show({
        message: this.translate.instant("Products.invalid"),
        type: SnackbarType.ERROR,
      });
      return;
    }

    if (
      this.productDataForm.pristine && 
      !this.creation && 
      !this.duplication
    ) {
      this.snackbarService.show({
        message: this.translate.instant("Products.NoChanges"),
        type: SnackbarType.WARNING,
      });
      return;
    }

    let product: any = {
      enabled: this.productDataForm.controls.enabled.value
        ? this.productDataForm.controls.enabled.value
        : false,
      isFuel: this.productDataForm.controls.isFuel.value
        ? this.productDataForm.controls.isFuel.value
        : false,
      promptQuantity: this.productDataForm.controls.promptQuantity.value
        ? this.productDataForm.controls.promptQuantity.value
        : false,
      customPrice: this.productDataForm.controls.customPrice.value
        ? this.productDataForm.controls.customPrice.value
        : false,
      promptPrice: this.productDataForm.controls.promptPrice.value
        ? this.productDataForm.controls.promptPrice.value
        : false,
      priceByWeight: this.productDataForm.controls.priceByWeight.value
        ? this.productDataForm.controls.priceByWeight.value
        : false,
      fiscalInfoRequired: this.productDataForm.controls.fiscalInfoRequired.value
        ? this.productDataForm.controls.fiscalInfoRequired.value
        : false,
      refundable: this.productDataForm.controls.refundable.value
        ? this.productDataForm.controls.refundable.value
        : false,
      canSellBelowBuyPrice: this.productDataForm.controls.canSellBelowBuyPrice.value
        ? this.productDataForm.controls.canSellBelowBuyPrice.value
        : false,
      description: this.productDataForm.controls.description.value
        ? this.productDataForm.controls.description.value
        : null,
      color: this.productDataForm.controls.productColor.value
        ? this.productDataForm.controls.productColor.value?.hex
        : null,
      imageUrl: this.productDataForm.controls.imageUrl.value
        ? this.productDataForm.controls.imageUrl.value
        : null,
      defaultQuantity: 
        this.productDataForm.controls.defaultQuantity.value ||
        this.productDataForm.controls.defaultQuantity.value === 0
          ? this.productDataForm.controls.defaultQuantity.value
          : null,
      maxSellDiscount: 
        this.productDataForm.controls.maxSellDiscount.value ||
        this.productDataForm.controls.maxSellDiscount.value === 0
          ? this.productDataForm.controls.maxSellDiscount.value
          : null,
      refundMaxPeriod:
        this.productDataForm.controls.refundMaxPeriod.value ||
        this.productDataForm.controls.refundMaxPeriod.value === 0
          ? this.productDataForm.controls.refundMaxPeriod.value
          : null,
      referenceUnitPrice: this.productDataForm.controls.referenceUnitPrice.value
        ? this.productDataForm.controls.referenceUnitPrice.value
        : 0,
      productUnitCode: this.productDataForm.controls.productUnitCode.value
        ? this.productDataForm.controls.productUnitCode.value
        : null,
      productTypeCode: this.productDataForm.controls.productTypeCode.value
        ? this.productDataForm.controls.productTypeCode.value
        : null,
      productFamilyCode: this.productDataForm.controls.productFamily.value?.code
        ? this.productDataForm.controls.productFamily.value.code
        : null,
      productGroupCode: this.productDataForm.controls.productGroup.value?.code
        ? this.productDataForm.controls.productGroup.value.code
        : null,
      taxCode: this.productDataForm.controls.tax.value.code
        ? this.productDataForm.controls.tax.value.code
        : null,
      shortDescription: this.productDataForm.controls.shortDescription.value
        ? this.productDataForm.controls.shortDescription.value
        : null,
      categories: CategoriesAndPropsUtils.setFormCategories(
        this.productDataForm.controls.categories.value
      ),
      properties: CategoriesAndPropsUtils.setFormProperties(
        this.productDataForm.controls.properties.value
      ),
      barcodes: this.productDataForm.controls.barcodes.value ?? null,
      productPack: this.productDataForm.controls.productPack.value 
        ? this.setPackProductCode(this.productDataForm.controls.productPack.value)
        : null,
      pack: !!this.productDataForm.controls.productPack.value.length && !this.productDataForm.controls.isFuel.value 
        ? true
        : false
    };

    if (this.currCode.length === 0) {
      this.store.dispatch(createProduct({ product: product }));
    } else {
      product = { ...product, code: this.currCode };
      this.store.dispatch(updateProduct({ product }));
    }

    this.productDataForm.markAsUntouched();
    this.productDataForm.markAsPristine();
  }

  setPackProductCode(packArr: PackExtendedDTO[]): PackDTO[] {
    return packArr.map(({ code, product, quantity }) => ({
      code,
      productCode: product.code,
      quantity,
    }));
  }

  refresh() {
    if (isAuthenticated(this.router.url) && !this.productDataForm.pristine) {
      this.confirmDialog(this.dialog, true);
      return;
    } else {
      this.reload();
    }
  }
  
  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["products/product", this.currCode]);
  }

  new() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["/products/product"]);
    this.creation = true;
  }

  duplicate() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    localStorage.setItem("duplicate", this.currCode);
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["products/product", {}]);
  }

  identify(index, item) {
    return item.code;
  }

  ngOnDestroy(): void {
    if (this.createdSub) {
      this.createdSub.unsubscribe();
    }
    if (this.multiSubs) {
      this.multiSubs.unsubscribe();
    }
    if (this.loadedProductSubs) {
      this.loadedProductSubs.unsubscribe();
    }
    if (this.messageSubs) {
      this.messageSubs.unsubscribe();
    }
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
    if (this.productFamiliesSub) {
      this.productFamiliesSub.unsubscribe();
    }
    if (this.productGroupsSub) {
      this.productGroupsSub.unsubscribe();
    }
  }
  
  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return this.isNavigationAllowed();
  }

  isNavigationAllowed(): Observable<boolean> | boolean {
    if (!isAuthenticated(this.router.url) || this.productDataForm.pristine) {
      return true;
    } else {
      return false;
    }
  }
}
